



































































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import Date from "@/service/ConvertDate/ConvertDate";
import Locale from "@/service/Locale/Locale";

interface InviteAdministratorProps {
  lang: any;
  licenseName: string;
}

interface InviteAdministratorData {
  administratorName: string;
  administratorInvitationUrl: string;
  isShowTooltip: boolean;
  urlExpiresTimestamp: string;
}

interface ReplaceText {
  replaceKey: string;
  replacementCharacter: string;
}
interface ReplaceDateText {
  replaceKey: string;
  timestamp: number;
}

export default Vue.extend({
  name: "vc-invite-administrator-modal",
  props: {
    lang: {
      type: Object as PropType<InviteAdministratorProps["lang"]>,
      default: () => {},
    },
    licenseName: {
      type: String as PropType<InviteAdministratorProps["licenseName"]>,
      default: "",
    },
    volumeLicensesId: {
      type: String,
      default: "",
    },
  },
  data(): InviteAdministratorData {
    return {
      administratorName: "",
      administratorInvitationUrl: "",
      isShowTooltip: false,
      urlExpiresTimestamp: "",
    };
  },
  computed: {
    ...mapGetters("inviteAdministrator", [
      "getAdministratorName",
      "getAdministratorInvitationUrl",
      "getUrlExpiresTimestamp",
    ]),
  },
  methods: {
    replaceText(
      text: string,
      replaceKey: string,
      replacementCharacter: string
    ) {
      return text.replace(replaceKey, replacementCharacter);
    },
    getConvertDateTime(timestamp: number) {
      return Date.getDateTime(timestamp, Locale.getLocale());
    },
    replaceDateText(text: string, replaceKey: string, timestamp: number) {
      return text.replace(replaceKey, this.getConvertDateTime(timestamp));
    },
    getReplacedText(
      text: string,
      textData1: ReplaceText,
      textData2: ReplaceText,
      dateTextData: ReplaceDateText
    ) {
      let replacedText = text;
      replacedText = this.replaceText(
        replacedText,
        textData1.replaceKey,
        textData1.replacementCharacter
      );
      replacedText = this.replaceText(
        replacedText,
        textData2.replaceKey,
        textData2.replacementCharacter
      );
      replacedText = this.replaceDateText(
        replacedText,
        dateTextData.replaceKey,
        dateTextData.timestamp
      );
      replacedText = replacedText.replace(/:br/g, "<br />");
      replacedText = replacedText.replace(
        /:url/g,
        this.getAdministratorInvitationUrl
      );
      return replacedText;
    },
    onClickCopy() {
      const copyContents = document.querySelector("[data-copy-contents]");
      if (copyContents === null) {
        return;
      }

      const input = document.createElement("textarea");
      input.setAttribute("id", "copyInput");
      const copyContentsText = copyContents.innerHTML as string;
      document.body.appendChild(input);
      input.value = copyContentsText
        .replace(/<br>/g, "\n")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&");
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);

      this.isShowTooltip = true;
      setTimeout(() => {
        this.isShowTooltip = false;
      }, 1000);
    },
  },
});
